<template>
  <div class="container" style="width:99%;margin-top:-25px;">
	<!--工具栏-->
	<div class="toolbar" style="float:left;padding-top:15px;padding-left:15px;">
<!--		<el-form :inline="true" :model="filters" :size="size">-->
<!--			<el-form-item style="margin-bottom: 0;">-->
<!--				<el-input v-model="filters.label" placeholder="名称"></el-input>-->
<!--			</el-form-item>-->
<!--			<el-form-item style="margin-bottom: 0;">-->
<!--				<kt-button :label="$t('action.search')" perms="sys:tAfoWaveDetailLine:view" type="primary" @click="findPage(null)"/>-->
<!--			</el-form-item>-->
<!--			<el-form-item style="margin-bottom: 0;">-->
<!--				<kt-button :label="$t('action.add')" perms="sys:tAfoWaveDetailLine:add" type="primary" @click="handleAdd" />-->
<!--			</el-form-item>-->
<!--		</el-form>-->
	</div>
<!--		</el-form>-->
	<!--表格内容栏-->
	<kt-table permsEdit="sys:tWaveMaster:edit" permsDelete="sys:tWaveMaster:delete" permsView="sys:tWaveMaster:view" :displayButtonEdit="false" :displayButtonDelete="false" :showBatchDelete="false"
		:data="pageResult" :columns="columns" :buttonEdit="$t('action.edit')" :buttonDelete="$t('action.delete')" :batchDelete="$t('action.batchDelete')" :pageNum=this.pageRequest.pageNum :pageSize=this.pageRequest.pageSize
		@findPage="findPage" @handleEdit="handleEdit" @handleDelete="handleDelete">
	</kt-table>
	<!--新增编辑界面-->
	<el-dialog :title="operation?$t('common.add'):$t('common.edit')" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
		<el-form :model="dataForm" label-width="80px" :rules="dataFormRules" ref="dataForm" :size="size">
			<el-form-item :label="$t('TAfoWaveDetailLine.id')" prop="id"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.waveDetailLineId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TAfoWaveDetailLine.waveDetailId')" prop="waveDetailId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.waveDetailId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TAfoWaveDetailLine.itemNumber')" prop="itemNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.itemNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TAfoWaveDetailLine.whId')" prop="whId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.whId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TAfoWaveDetailLine.lineNumber')" prop="lineNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.lineNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TAfoWaveDetailLine.lotNumber')" prop="lotNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.lotNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TAfoWaveDetailLine.plannedQty')" prop="plannedQty"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.plannedQty" auto-complete="off"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
			<el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
		</div>
	</el-dialog>
  </div>
</template>

<script>
import KtTable from "@/views/Core/KtTable"
import KtButton from "@/views/Core/KtButton"
import { format } from "@/utils/datetime"
export default {
  name: 'TAfoWaveDetailLine',
	components:{
			KtTable,
			KtButton
	},
	data() {
		return {
			size: 'small',
			filters: {
				id: ''
			},
			columns: [
				{prop:"id", label:"TAfoWaveDetailLine.id", minWidth:100},
				{prop:"waveDetailId", label:"TAfoWaveDetailLine.waveDetailId", minWidth:100},
        {prop:"whId", label:"TAfoWaveDetailLine.whId", minWidth:100},
				{prop:"itemNumber", label:"TAfoWaveDetailLine.itemNumber", minWidth:100},
				{prop:"lineNumber", label:"TAfoWaveDetailLine.lineNumber", minWidth:100},
				{prop:"lotNumber", label:"TAfoWaveDetailLine.lotNumber", minWidth:100},
				{prop:"plannedQty", label:"TAfoWaveDetailLine.plannedQty", minWidth:100},
			],
			pageRequest: { pageNum: 1, pageSize: 1000 },
			pageResult: {},

			operation: false, // true:新增, false:编辑
			editDialogVisible: false, // 新增编辑界面是否显示
			editLoading: false,
			dataFormRules: {
			},
			// 新增编辑界面数据
			dataForm: {
				waveDetailLineId: null,
				waveDetailId: null,
				itemNumber: null,
				whId: null,
				lineNumber: null,
				lotNumber: null,
				plannedQty: null,
}
}
	},
	methods: {
    getParentParams: function () {
      this.filters.id=this.$route.query.id
      this.findPage(null)
    },
		// 获取分页数据
		findPage: function (data) {
			if(data !== null && data.pageRequest) {
				this.pageRequest.pageNum = data.pageRequest.pageNum
				this.pageRequest.pageSize = data.pageRequest.pageSize
			}
			this.pageRequest.columnFilters = {id:{name:"id",value:this.filters.id}}
			this.$wmsApi.tAfoWaveDetailLine.findPage(this.pageRequest).then((res) => {
				this.pageResult = res.data
			}).then(data!=null?data.callback:'')
		},
		// 批量删除
		handleDelete: function (data) {
			this.$wmsApi.tAfoWaveDetailLine.batchDelete(data.params).then(data!=null?data.callback:'')
		},
		// 显示新增界面
		handleAdd: function () {
			this.editDialogVisible = true
			this.operation = true
			this.dataForm = {
				waveDetailLineId: null,
				waveDetailId: null,
				itemNumber: null,
				whId: null,
				lineNumber: null,
				lotNumber: null,
				plannedQty: null,
}
},
		// 显示编辑界面
		handleEdit: function (params) {
			this.editDialogVisible = true
			this.operation = false
			this.dataForm = Object.assign({}, params.row)
		},
		// 编辑
		submitForm: function () {
			this.$refs.dataForm.validate((valid) => {
				if (valid) {
					this.$confirm(this.$t("common.message.confirmSubmission")+'', this.$t("common.message.prompt")+'', {confirmButtonText: this.$t("common.message.confirm")+'', cancelButtonText: this.$t("common.message.cancel")+''}).then(() => {
						this.editLoading = true
						let params = Object.assign({}, this.dataForm)
						this.$wmsApi.tAfoWaveDetailLine.save(params).then((res) => {
							if(res.code == 200) {
								this.$message({ message: this.$t("common.message.success")+'', type: 'success' })
				}
else {
								this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
				}
this.editLoading = false
							this.$refs['dataForm'].resetFields()
							this.editDialogVisible = false
							this.findPage(null)
						})
					})
	}
})
		},
		// 时间格式化
	dateFormat: function (row, column, cellValue, index){
    return format(row[column.property])
    }
	},
  activated: function () {
	  this.getParentParams()
  },
  mounted() {
	}
}
</script>

<style scoped>
/* 工业软件风格 - 工具栏整体布局 */
.toolbar {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}

/* 筛选条件区 - 工业软件卡片风格 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 10px;
}

/* 筛选分组 */
.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
  margin-right: 6px;
}

/* 筛选分隔线 */
.filter-divider {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent 0%, #dcdfe6 50%, transparent 100%);
  margin: 0 4px;
}

/* 单个筛选项 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* 筛选标签 */
.filter-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
  min-width: 52px;
  text-align: right;
}

/* 操作按钮区 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
}

/* 响应式 - 小屏幕 */
@media screen and (max-width: 1200px) {
  .filter-bar {
    padding: 8px 10px;
  }
  .filter-label {
    display: none;
  }
  .filter-group {
    border-right: none;
    padding-right: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Wms/TAfoWaveDetailLine.vue